import { rest, RestHandler } from 'msw';
import { PATHS } from 'adapters/constants';

export const pdfGenerationHandler: RestHandler[] = [
  rest.get(
    `${PATHS.getAccountingVirtualCardPdfGeneration()}/*`,
    (_, res, ctx) =>
      res(
        ctx.status(200),
        ctx.json({
          content: ''
        })
      )
  )
];
